function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from "react";
import PictureComponent from "/components/core/picture/picture-component";
import Colors from "/styles/colors";
import { WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";
import { GRID_TAG_CLICKED, GRID_TAG_HOVERED } from "/constants/bigbrain-event-types";
import { trackEvent } from "/services/bigbrain-service";
import classnames from "classnames";
import { generateOnKeyDownHandler } from "/client/services/accessibility/accessibility-service";
import DataLayerEventTypes from "constants/data-layer-event-types";
import { fireGtmEvent } from "client/services/gtm-service/gtm-service";
import TagCheckbox from "./components/tag-checkbox";
import { StyledSquareTagComponent } from "./square-tag-component.scss";
const SquareTagComponent = (props)=>{
    const CLUSTER_CLICK_ANIMATION_TIME = 300;
    const [isHovered, setIsHovered] = useState(false);
    const [wasClusterSelected, setWasClusterSelected] = useState(false);
    const { starText, starImage, starColorName, onStarClick, tagScheme, isSelected, isDarkTheme, checkboxScheme, textScheme, showBorderInLightTheme, productType } = props;
    const blurTag = (e)=>{
        var _e_target_closest, _e_target;
        e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(`.square-tag-component`)) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
    };
    const getCurrentColor = useCallback((selectedColor, hoverColor, baseColor)=>{
        if (isSelected) return Colors[selectedColor];
        return isHovered ? Colors[hoverColor] : Colors[baseColor];
    }, [
        isHovered,
        isSelected
    ]);
    const tagBackgroundColor = useMemo(()=>getCurrentColor(tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor, tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.hoverColor, null), [
        getCurrentColor,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.hoverColor,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor
    ]);
    const tagTextColor = useMemo(()=>getCurrentColor(textScheme === null || textScheme === void 0 ? void 0 : textScheme.selectedColor, textScheme === null || textScheme === void 0 ? void 0 : textScheme.hoverColor, textScheme === null || textScheme === void 0 ? void 0 : textScheme.color), [
        getCurrentColor,
        textScheme === null || textScheme === void 0 ? void 0 : textScheme.selectedColor,
        textScheme === null || textScheme === void 0 ? void 0 : textScheme.hoverColor,
        textScheme === null || textScheme === void 0 ? void 0 : textScheme.color
    ]);
    const onClick = (e)=>{
        blurTag(e);
        onTagSelection();
        trackEvent(GRID_TAG_CLICKED, {
            kind: starText,
            info1: productType
        });
        fireGtmEvent(DataLayerEventTypes.TAG_SELECTED, {
            name: starText
        });
    };
    const onTagSelection = ()=>{
        setWasClusterSelected(true);
        setTimeout(()=>setWasClusterSelected(false), CLUSTER_CLICK_ANIMATION_TIME);
        onStarClick && onStarClick();
    };
    const tagBorderColor = useMemo(()=>{
        if ((tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor) && isSelected) return Colors[tagScheme.selectedBackgroundColor];
        return (tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.hoverColor) && isHovered ? Colors[tagScheme.hoverColor] : Colors[tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.borderColor];
    }, [
        isHovered,
        isSelected,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.borderColor,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.hoverColor,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor
    ]);
    const onMouseOver = ()=>{
        setIsHovered(true);
        trackEvent(GRID_TAG_HOVERED, {
            kind: starText
        });
    };
    const onMouseLeave = ()=>setIsHovered(false);
    const starColor = Colors[tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor] || Colors[starColorName] || Colors[WORK_OS_IRIS_COLOR_NAME];
    return /*#__PURE__*/ _jsxs(StyledSquareTagComponent, {
        className: classnames("square-tag-component", {
            selected: isSelected,
            hovered: isHovered,
            "selectable-cluster": true,
            "light-theme": !isDarkTheme,
            "cluster-selected": wasClusterSelected,
            "show-border-in-light-theme": showBorderInLightTheme
        }),
        style: {
            color: starColor,
            borderColor: tagBorderColor,
            backgroundColor: tagBackgroundColor
        },
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        onKeyDown: generateOnKeyDownHandler(onTagSelection),
        tabIndex: 0,
        role: "checkbox",
        "aria-checked": isSelected,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "background-circle"
            }),
            /*#__PURE__*/ _jsx(TagCheckbox, _object_spread_props(_object_spread({}, checkboxScheme), {
                isSelected: isSelected,
                tagBorderColor: tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.borderColor
            })),
            /*#__PURE__*/ _jsx("div", {
                className: "star-image",
                children: /*#__PURE__*/ _jsx(PictureComponent, {
                    className: "star-icon",
                    pictureClass: "star-picture",
                    src: starImage
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "star-text",
                style: {
                    color: tagTextColor
                },
                children: starText
            })
        ]
    });
};
export default SquareTagComponent;
SquareTagComponent.defaultProps = {
    starText: "Marketing",
    starImage: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/Marketing_icon_circle.png",
    starColorName: "marketing-red"
};
